<div [formGroup]="form">
  <div class="control-container" *ngIf="!notificationId && notificationId !== ''">
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.LABEL_TYPE' | translate }}
      </glxy-label>
      <mat-select [formControl]="notificationChannel" required="true">
        <mat-option [value]="genericNotificationID">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.GENERIC' | translate }}
        </mat-option>
        <mat-option [value]="highPriorityAutomationNotificationID">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.HIGH_PRIORITY' | translate }}
        </mat-option>
        <mat-option [value]="hotLeadsNotificationID" *ngIf="isSalesperson">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATION_TO_THE_USER.NOTIFICATION_OPTIONS.HOT_LEADS' | translate }}
        </mat-option>
      </mat-select>
      <glxy-hint class="external-hint">
        <automata-notifications-settings-link></automata-notifications-settings-link>
      </glxy-hint>
    </glxy-form-field>
  </div>
  <div class="description title">
    {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.IN_APP_NOTIFICATION' | translate }}
  </div>
  <div class="control-container">
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.NOTIFICATION_MESSAGE' | translate }}
      </glxy-label>
      <textarea
        id="in-app-notification-message"
        matInput
        [formControl]="inAppText"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="8"
        [placeholder]="notificationMessagePlaceholderKey | translate"
        [required]="true"
      ></textarea>
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        [supportedDataTypes]="allDataTypes"
        (variableSelected)="insertVariable('in-app-notification-message', inAppText, $event)"
      ></automata-automation-variable-menu>
      <glxy-error *ngIf="inAppText.hasError('required') && !!inAppText?.dirty">
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.REQUIRED_FIELD' | translate }}
      </glxy-error>
    </glxy-form-field>
  </div>
  <div class="control-container">
    <glxy-form-field required="true">
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.LINK' | translate }}</glxy-label>
      <input matInput [required]="true" [formControl]="inAppLinkTemplate" id="notification-url" />
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        [supportedDataTypes]="allDataTypes"
        [dontIncludeDefaultCategories]="true"
        (variableSelected)="insertVariable('notification-url', inAppLinkTemplate, $event)"
      ></automata-automation-variable-menu>
      <glxy-hint
        class="external-hint"
        [innerHtml]="
          'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.LINK_HELP_TEXT'
            | translate
              : {
                  userType: (userTypeKey | translate | automataCapitalize),
                }
            | iTrustThisHtml
        "
      ></glxy-hint>
    </glxy-form-field>
  </div>
  <div class="description title">
    {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.EMAIL_NOTIFICATION' | translate }}
  </div>
  <div class="control-container">
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.NOTIFICATION_SUBJECT' | translate }}
      </glxy-label>
      <input matInput id="email-subject" [formControl]="emailSubject" [required]="true" />
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        [supportedDataTypes]="allDataTypes"
        (variableSelected)="insertVariable('email-subject', emailSubject, $event)"
      ></automata-automation-variable-menu>
    </glxy-form-field>
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.NOTIFICATION_MESSAGE' | translate }}
      </glxy-label>
      <automata-html-editor
        elementId="email-content"
        [formControl]="emailBody"
        [required]="true"
        [menu]="editorMenu"
        toolbar="bold italic underline strikethrough alignleft aligncenter alignright bullist numlist outdent indent link unlink media image code"
        plugins="code media link image lists"
        menubar="format insert tools"
        height="300px"
      ></automata-html-editor>

      <glxy-error *ngIf="emailBody.hasError('required') && !!emailBody?.dirty">
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.REQUIRED_FIELD' | translate }}
      </glxy-error>
    </glxy-form-field>
  </div>
  <div class="control-container">
    <glxy-form-field required="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.BUTTON_TEXT' | translate }}
      </glxy-label>
      <input matInput id="email-button-text" [formControl]="emailButtonText" [required]="true" />
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        [supportedDataTypes]="allDataTypes"
        (variableSelected)="insertVariable('email-button-text', emailButtonText, $event)"
      ></automata-automation-variable-menu>
      <glxy-error *ngIf="emailButtonText.hasError('required') && !!emailButtonText?.dirty">
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.REQUIRED_FIELD' | translate }}
      </glxy-error>
      <glxy-error *ngIf="emailButtonText.hasError('url') && !!emailButtonText?.dirty">
        {{ 'COMMON.VALIDATORS.INVALID_URL' | translate }}
      </glxy-error>
    </glxy-form-field>
    <glxy-form-field required="true">
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.LINK' | translate }}</glxy-label>
      <input matInput [formControl]="emailLinkTemplate" [required]="true" id="notification-link" />
      <automata-automation-variable-menu
        matSuffix
        useGalaxyCompat="true"
        [supportedDataTypes]="allDataTypes"
        [dontIncludeDefaultCategories]="true"
        (variableSelected)="insertVariable('notification-link', emailLinkTemplate, $event)"
      ></automata-automation-variable-menu>
      <glxy-error *ngIf="emailLinkTemplate.hasError('required') && !!emailLinkTemplate?.dirty">
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_IN_APP_NOTIFICATION.REQUIRED_FIELD' | translate }}
      </glxy-error>
      <glxy-error *ngIf="emailLinkTemplate.hasError('url') && !!emailLinkTemplate?.dirty">
        {{ 'COMMON.VALIDATORS.INVALID_URL' | translate }}
      </glxy-error>
    </glxy-form-field>
  </div>
</div>
